import { render, staticRenderFns } from "./BannerLeft.vue?vue&type=template&id=16de865c&scoped=true&"
import script from "./BannerLeft.vue?vue&type=script&lang=js&"
export * from "./BannerLeft.vue?vue&type=script&lang=js&"
import style0 from "./BannerLeft.vue?vue&type=style&index=0&id=16de865c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16de865c",
  null
  
)

export default component.exports